<script>
    export let phoneNumber = '';
    export let propsForForm;
    // export let onClose;
    let link = '';
    let isCopied = false;

    const subscription = propsForForm && propsForForm[0]

    const createInvite = () => {
        fetch(`/api/v1/create-invite/${subscription.id}`, {
            body: JSON.stringify({
                phoneNumber,
            }),
            method: 'POST',
        })
        .then(data => data.json())
        .then(response => {
            ({ link } = response);
            // onClose();
            // show the link in the ui

            navigator.clipboard.writeText(link)
                .then(
                    () => { isCopied = true }, 
                    () => { isCopied = false }
                )

        });
    }
</script>

<div>
    {#if link}
        <div>
            {#if isCopied}
                <div>copied to clipboard</div>
            {/if}
            <span>{link}</span>
        </div>
    {/if}
    <form id="new-invite-form">
        <input bind:value={phoneNumber} class="input" type="text" name="invite-phone" autocomplete="off" placeholder="Mobile number" data-required="true" required />
        <button on:click|preventDefault={() => createInvite()} type="submit" form="new-invite-form" class="primary-red">
            Get invite link
        </button>
    </form>
</div>


<style>
    #new-invite-form {
        display: flex;
        flex-direction: column;
    }
</style>